import { defLanguage, languages } from '@/constant/language';
import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
    locales: languages,
    defaultLocale: defLanguage,
    localePrefix: 'as-needed',
    localeDetection: false,
});
